import { SKU_MAPPING } from '@constants/schemaConstants'
import {
  findHtmlElements,
  getFollowingHtmlElementSiblings,
  getHtmlText,
  HTML_HEADING_TAGS,
  parseHtmlFragment,
} from '@utils/htmlAst'

export const getHeadingDesc = (content, fullDescription = false) => {
  const result = {
    heading: '',
    description: '',
  }
  if (typeof content !== 'string') return result

  const root = parseHtmlFragment(content)

  // Iterate through all heading tags (h1–h6)
  const heading = findHtmlElements(root, ...HTML_HEADING_TAGS)[0]

  if (heading) {
    // If a heading exists, extract its text
    result.heading = getHtmlText(heading).trim()
    const followingSiblings = getFollowingHtmlElementSiblings(heading)

    if (fullDescription) {
      // Get everything after the heading
      result.description = followingSiblings.map(getHtmlText).join(' ').trim()
    } else {
      // Only get the next paragraph
      const nextParagraph = followingSiblings.find(element => element.tagName === 'p')
      if (nextParagraph) result.description = getHtmlText(nextParagraph).trim()
    }
  } else {
    // No heading found — use the whole content as description
    result.description = findHtmlElements(root, 'p').map(getHtmlText).join(' ').trim()
  }

  return result
}

export const generateImageSchema = (url?: string | null, alt?: string, urlAttribute = 'contentUrl') => {
  const imageUrl = url?.trim()
  if (!imageUrl || imageUrl.toLowerCase().startsWith('data:')) return null
  const fileName = imageUrl.split('/').pop()?.split(/[?#]/)[0]?.split('.')[0]
  if (!fileName) {
    return {
      '@context': 'https://schema.org',
      '@type': 'ImageObject',
      [urlAttribute]: imageUrl,
      name: imageUrl,
      description: alt ?? imageUrl,
    }
  }
  const cleaned = fileName
    .replace(/[_-]+/g, ' ') // Replace underscores/hyphens
    .replace(/\b(webp|jpg|jpeg|png)\b/gi, '') // Remove format words
    .replace(/[_-]?[a-f0-9]{6,}$/i, '') // Remove hash-like suffix
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase()) // Capitalize words

  return {
    '@context': 'https://schema.org',
    '@type': 'ImageObject',
    [urlAttribute]: imageUrl,
    name: cleaned,
    description: alt ?? cleaned,
  }
}

export function resolveSKU(category = '', subCategory = '') {
  const text = `${category} ${subCategory}`.toLowerCase()

  const match = SKU_MAPPING.find(map => map.keywords.some(k => text.includes(k)))

  return match ? match.value : null
}
